import Search from '../search/search.js'
module.exports = {
  Search
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/search/index.js